<template>
    <v-tooltip v-bind="tooltipOptions" v-model="show" :disabled="hasAccess">
        <template #activator="{ on }">
            <span v-on="on" :class="`d-inline-block `+ containerClass">
              <v-btn
                      @click="e => $emit('click', e)"
                      :disabled="disabled || !hasAccess"
                      :href="href"
                      :color="color"
                      :class="buttonClass"
                      :loading="loading"
              >
                <slot></slot>
              </v-btn>
            </span>
        </template>
        <span v-if="!hasAccess"
              v-html="trans(noPermissionToolTip !== '' && isUserActive ? noPermissionToolTip : 'app.no_access_tooltip')"></span>
    </v-tooltip>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    data: () => ({
        show: false,
    }),
    props: {
        color: String,
        buttonClass: String,
        containerClass: {
          type: String,
          default: '',
        },
        href: {
            type: String,
            required: false,
        },
        permission: {
            type: [String, Function, Boolean],
            required: false,
            default: () => null,
        },
        tooltip: {
            type: Object,
            required: false,
            default: () => {
            },
        },
        noPermissionToolTip: {
            type: String,
            default: ''
        },
        loading: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        ...mapGetters([
            'hasPermission',
            'isUserActive'
        ]),

        hasAccess() {
            if (typeof this.permission === 'string') {
                return this.hasPermission(this.permission);
            }

            if (typeof this.permission === 'boolean') {
                return this.permission;
            }

            if (typeof this.permission === 'function') {
                return this.permission(this.hasPermission);
            }

            return true;
        },

        tooltipOptions() {
            const defaults = {
                'bottom': true,
                'attach': true,
                'offset-overflow': true,
                'lazy': true,
                ...this.tooltip,
            };

            if (this.hasAccess) {
                return defaults;
            }

            return {
                'close-delay': 2000,
                'max-width': 300,
                ...defaults,
            };
        },
    },
};
</script>

<style scoped>
.v-tooltip__content span {
    text-align: left;
    display: block;
    width: 100%;
}
</style>
